import React from 'react'
import { useTranslation } from 'react-i18next'
import icons from '../assets/icons'

const CruisingStatus: React.FC = () => {
  const { t } = useTranslation()
  return (
    <div className='marker--infoSection--cruiseStatus'>
      <img
        alt='cruising'
        src={icons['cruising-status']}
        className='marker--infoSection--cruiseStatus--image'
      />
      <div className='text text--size14'>
        {t('cruising')}
      </div>
    </div>
  )
}

export default CruisingStatus
